export default __webpack_public_path__ + "static/media/arduino.afb8ab21.svg";